import axios from 'axios'
import Cookies from 'js-cookie'
import {
    Message
} from 'element-ui'
// axios.defaults.baseURL = 'http://wwww.xxxxx.com/';
//请求拦截器
axios.interceptors.request.use(
    config => {
        // const token = Cookies.get('token');
        // if (token) {
        //     //一般需要加，但有的时候不能加，加了反而会报错
        //     config.headers['Authorization'] = token;
        // }
        return config;
    },
    error => {
        // Message.error({
        //     message: '请求超时'
        // })
        return Promise.reject(err);
    }
);
// 拦截服务端响应的信息
axios.interceptors.response.use(data => {

    // if (data.data.code != 1000) {
    //     // Message.error({
    //     //     message: data.data.message
    //     // })
    //     return
    // }
    // 返回方法调用的那里，拿到的就是服务端返回的数据
    // if (data.data.data) {
    //     return data.data
    // } else {
    //     return data.data
    // }
    return data.data
}, err => {
    // 如果HTTP响应码是400,500等就会进入这个err函数中
    // 如果服务器没启动或者是路径错误进入此判断中
    // if (err.response.status === 504 || err.response.status === 404) {
    //     // Message.error({
    //     //     message: '服务器连接失败'
    //     // })
    // } else if (err.response.status === 403) { // 表示权限不足
    //     Message.error({
    //         message: '权限不足，请联系管理员'
    //     })
    // } else if (err.response.status === 401) { // 表示未登录
    //     Message.error({
    //         message: err.response.data.msg // 服务器返回来的信息
    //     })
    // } else {
    //     if (err.response.data.msg) {
    //         Message.error({
    //             message: err.response.data.msg
    //         })
    //     } else {
    //         Message.error({
    //             message: '未知错误'
    //         })
    //     }
    // }
})
// get请求接口
export const getRequest = (url) => {
    return axios({
        method: 'get',
        url: `${url}`
    })
}
// post请求接口
export const postRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json'
            //看接口后端需要什么格式的，自行调整
            //'Content-Type':'application/x-www-form-urlencoded'
        }
    })
}
// 文件上传接口
export const uploadFileRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${url}`,
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
// put请求接口
export const putRequest = (url, params) => {
    return axios({
        method: 'put',
        url: `${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// delete请求接口
export const deleteRequest = (url) => {
    return axios({
        method: 'delete',
        url: `${url}`
    })
}
//把对象或者数组直接转化成datafrom的形式，不用一个一个append
// let formData = new FormData();
// this.$makeForm(this.param, formData);
export const makeFormData = (obj, form_data) => {
    var data = [];
    if (obj instanceof File) {
        data.push({
            key: "",
            value: obj
        });
    } else if (obj instanceof Array) {
        for (var j = 0, len = obj.length; j < len; j++) {
            var arr = makeFormData(obj[j]);
            for (var k = 0, l = arr.length; k < l; k++) {
                var key = !!form_data ? j + arr[k].key : "[" + j + "]" + arr[k].key;
                data.push({
                    key: key,
                    value: arr[k].value
                })
            }
        }
    } else if (typeof obj == 'object') {
        for (var j in obj) {
            var arr = makeFormData(obj[j]);
            for (var k = 0, l = arr.length; k < l; k++) {
                var key = !!form_data ? j + arr[k].key : "[" + j + "]" + arr[k].key;
                data.push({
                    key: key,
                    value: arr[k].value
                })
            }
        }
    } else {
        data.push({
            key: "",
            value: obj
        });
    }
    if (!!form_data) {
        // 封装
        for (var i = 0, len = data.length; i < len; i++) {
            form_data.append(data[i].key, data[i].value)
        }
    } else {
        return data;
    }
}